module.exports = shared.Markerwithlabel;